import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { SignalSection } from '../components/SignalSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BibliotecaSection } from '../components/BibliotecaSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
export function LandingPage() {
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-287">
      <HeroSection data-id="element-288" />

      <SignalSection data-id="element-289" />

      <ProtocolSection data-id="element-290" />

      <BenefitsSection data-id="element-291" />
      <PainSection data-id="element-292" />

      <TestimonialsSection data-id="element-293" />

      <DifferenceSection data-id="element-294" />

      

      <ForWhoSection data-id="element-295" />

      <BibliotecaSection data-id="element-296" />

      <OfferSection data-id="element-297" />

      <AboutSection data-id="element-298" />

      <FAQSection data-id="element-299" />

      <FinalCTASection data-id="element-300" />
    </main>;
}